// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"600":"026cb774","734":"026cb774","888":"026cb774"}[chunkId] + ".chunk.css";
};